import axios from "axios";
import api from "../../../../../services/axios";

export const CheckLeadByPhoneNo = async (phoneNo) => {
  try {
    const response = await api.post("/Employee/Lead/CheckLeadByPhoneNo", { phoneNo });
    return response.data;
  }
  catch (error) {
    throw error?.response?.data || "Something went wrong";
  }
}

export const CreateLead = async (data) => {
  try {
    const response = await api.post("/Employee/Lead/CreateLead", data);
    return response.data;
  } catch (error) {
    throw error?.response?.data || "Something went wrong";
  }
};

export const CreateRecruitmentLead = async (data) => {
  try {
    const response = await api.post("/Employee/RecruitmentLead/CreateRecruitmentLead", data);
    return response.data;
  } catch (error) {
    throw error?.response?.data || "Something went wrong";
  }
};

export const RequestLeadTransfer = async (recruitmentUID) => {
  try {
    const response = await api.post("/Employee/Lead/TransferLead", { recruitmentUID });
    return response.data;
  } catch (error) {
    throw error?.response?.data || "Something went wrong";
  }
};

export const GetMyLeads = async (chunkNumber = 1, search = "") => {
  try {
    const res = await api.get(`/Employee/Lead/GetMyLeads?chunkNumber=${chunkNumber}&searchF=${search}`);
    return res?.data;
  }
  catch (error) {
    throw error?.response?.data
  }
};

export const GetManagerLeads = async (selectedEmployeeCode = "", chunkNumber = 1, search = "") => {
  try {
    const res = await api.get(`/Employee/Lead/GetManagerLeads?selectedEmployeeCode=${selectedEmployeeCode}&chunkNumber=${chunkNumber}&searchF=${search}`);
    return res?.data;
  }
  catch (error) {
    throw error?.response?.data
  }
};

export const GetManagerTeamMembers = async () => {
  try {
    const res = await api.get("/Employee/Lead/GetManagerTeamMembers");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const UpdateBasicDetails = async (payload) => {
  try {
    const res = await api.post("/Employee/Lead/EditBasicDetails", payload);
    return res?.data;
  }
  catch (error) {
    return error?.response?.data;
  }
};

export const GetSourceMetaData = async () => {
  try {
    const res = await api.get("/RecruitmentLead/GetSourceData");
    return res?.data;
  }
  catch (error) {
    return error?.response?.data;
  }
};